'use strict';

import Immutable from 'immutable';

var React = require('react');
var Picture = require('../elements/Picture');
// var Episode = require('../episodes/Episode.jsx');
var LatestEpisodes = require('../episodes/LatestEpisodes.jsx');
var LatestArticles = require('./LatestArticles');
var urlUtils = require('../../utils/urlUtils');
var LinkButton = require('../elements/LinkButton.jsx');
var SVTLink = require('../elements/SVTLink');

var svtChannels = require('../../utils/channels.js');
var ChannelText = require('../elements/ChannelText.jsx');

var BroadcastInfo = React.createClass({
	displayName: 'BroadcastInfo',

	propTypes: {
		model: React.PropTypes.shape({
			broadcastTime: React.PropTypes.string,
			broadcastChannel: React.PropTypes.string
		}).isRequired
	},
	
	render: function () {

		var broadcastTime;
		var broadcastChannel;
		var isWebExclusive = false;

		if (this.props.model.broadcastTime) {
			broadcastTime = this.props.model.broadcastTime;
		}

		if (this.props.model.broadcastChannel){
			broadcastChannel = this.props.model.broadcastChannel;
			if(svtChannels[broadcastChannel]){
				isWebExclusive = !svtChannels[broadcastChannel].broadcast;
			}
		}

		if (!broadcastTime && !broadcastChannel) {
			return (
				<div className="svtse_program__broadcast-info">
					<SVTLink to={urlUtils.scheduleTitleSearchUrl(this.props.model.title)} className="svtse_program__broadcast-search">Hitta TV-tider <i className="svt_icon svt_icon--arrow-right"></i></SVTLink>
				</div>
			);
		}

		if(isWebExclusive){
			return (
			<div className="svtse_program__broadcast-info">
				<h3 className="svtse_program__broadcast-headline">
					<span className="svtse_program__broadcast-channel">
						<ChannelText channel={broadcastChannel} />
					</span> <span className="svtse_program__broadcast-time">{broadcastTime}</span>
				</h3>
			</div>
			);
		}

		return (
			<div className="svtse_program__broadcast-info">
				<h3 className="svtse_program__broadcast-headline">
					<span className="svtse_program__broadcast-channel">
						<ChannelText channel={broadcastChannel} />
					</span> <span className="svtse_program__broadcast-time">{broadcastTime}</span>
				</h3>
				<SVTLink to={urlUtils.scheduleTitleSearchUrl(this.props.model.title)} className="svtse_program__broadcast-search">Hitta TV-tider <i className="svt_icon svt_icon--arrow-right"></i></SVTLink>
			</div>
		);
	}
});

var FaqLink = React.createClass({
	displayName: 'FaqLink',
	render: function () {

		return (
			<div className="svtse_program__faq">

				<LinkButton url={urlUtils.faqTitleSearchUrl(this.props.model.title)}>
					Vanliga frågor om <span className="svtse_button__link-ellipsis">{this.props.model.title}</span>
				</LinkButton>

			</div>
		);
	}

});

var CreditLink = React.createClass({
	displayName: 'CreditLink',

	render: function () {

		var model = this.props.model;

		if (!model.creditlist) {
			return false;
		}

		var url = '/' + model.id + '/' + model.creditlist.id;

		return (
			<SVTLink className="svtse_program__credit" to={url}>
				Medverkande och medarbetare.
			</SVTLink>
		);
	}

});


var ProgramEpisodes = React.createClass({
	displayName: 'ProgramEpisodes',

	render: function() {
		var model = this.props.model;

		if (!model) {
			return false;
		}

		var episodes = model.episodes || [];

		if (episodes.length === 0) {
			return (
				<div className="svtse_latest-episodes--empty">
					Just nu finns inga avsnitt av {model.title} tillgängliga.
				</div>
			);
		}


		var destinationName = (model.primaryDestination === 'KIDS') ? "Barnkanalen" : "SVT Play";

		return (
			<span>
				<div className="svtse_program__episodes-header-col">
					<h2 className="svtse_program__episodes-header">Hela program på {destinationName}</h2>
				</div>

				<LatestEpisodes program={model} />

			</span>
		);
	}
});

var Articles = React.createClass({
	displayName: 'Articles',

	render: function() {
		var model = this.props.model;

		if (!model) {
			return false;
		}

		var articles = model.articles || [];

		if (articles.length === 0) {
			return false;

			/* (
				<div className="svtse_latest-articles--empty">
					Just nu finns inga artiklar skrivna om {model.title}.
				</div>
			);
			*/
		}

		return (
			<span>
				<div className="svtse_program__articles-header-col">
					<h2 className="svtse_program__articles-header">Senaste artiklarna</h2>
				</div>

				<LatestArticles program={model} />

			</span>
		);
	}
});

var ImageLayout = React.createClass({
	displayName: 'ImageLayout',

	propTypes: {
		model: React.PropTypes.object.isRequired
	},

	_renderKidsLayout: function() {
		var image = this.props.model.character;
		var src = image.alternateSrc.replace(/\{image_versions.name\}/, 'square_large');

		return (
			<div className="svtse_program-kids">
				<figure className="svtse_program-kids__fig">
					<img className="svtse_program-kids__img" src={src} alt={image.altText} title={image.title} />
				</figure>
			</div>
		);
	},

	render: function() {
		var model = this.props.model;

		if (model.primaryDestination === 'KIDS') {
			return (
				<div className="svtse_program__row">
					{this._renderKidsLayout()}
				</div>
			);
		}

		return (
			<div className="svtse_program__row">
				<Picture className="svtse_program__fig" model={model.cover} type="extralarge_imax"/>
			</div>
		);
	}

});

class Program extends React.Component {

	shouldComponentUpdate(nextProps) {
		return !Immutable.is(this.props.model, nextProps);
	}

	render() {

		if (!this.props.model || this.props.model.isEmpty()) {
			return false;
		}


		const model = this.props.model.toJS();

		return (
			<section className="svtse_program">
				<article className="svtse_program__article" ref="programArticle">

					<div className="svtse_program__media">
						<div className="svtse_program__container">
							<ImageLayout model={model}/>
						</div>
					</div>

					<div className="svtse_program__container">
						<div className="svtse_program__row">
							<div className="svtse_program__bottom">
								<div className="svtse_program__header-col">
									<h1 className="svtse_program__header">
										{model.title}
									</h1>

									<h2 className="svtse_program__description">
										{model.shortDescription}
									</h2>

									<BroadcastInfo model={model} />
								</div>

								<div className="svtse_program__text-col">
									<div className="svtse_program__text">
										{model.description}
										<CreditLink model={model} />
									</div>
								</div>

								<FaqLink model={model} />
							</div>
						</div>

						<div className="svtse_program__row">
							<div className="svtse_program__episodes-col">
								<ProgramEpisodes model={model} />
							</div>
						</div>

						<div className="svtse_program__row">
							<div className="svtse_program__articles-col">
								<Articles model={model} />
							</div>
						</div>

					</div>

				</article>
			</section>
		);
	}
}

Program.propTypes = {
		model: React.PropTypes.object.isRequired
};

export default Program;



/** WEBPACK FOOTER **
 ** ./app/components/Program/index.js
 **/